
export const quoteCharDefaultForCsv: string = '"';
export const escapeCharDefaultForCsv: string = '\\';
